export default "__VITE_ASSET__Hh5AWh6z__"